'use client';

import { tema } from '@styles/theme';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import { useEffect, useState } from 'react';

const Template = ({ children }: { children?: React.ReactNode }) => {
  const [renderizarNoCliente, atribuirRenderizarNoCliente] = useState(false);

  useEffect(() => {
    atribuirRenderizarNoCliente(true);
  }, []);

  return (
    <>
      {renderizarNoCliente && (
        <ProgressBar
          height='4px'
          color={tema.cores.info.variantes[300]}
          options={{ showSpinner: false }}
          shallowRouting
        />
      )}
      {children}
    </>
  );
};

export default Template;
